import { StyleSheet, Platform, Dimensions } from "react-native";

const { width, height } = Dimensions.get('window');

// Get device pixel ratio to detect high-DPI displays  
const pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

// Enhanced responsive breakpoints - specifically handles 13-inch 1440p displays
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
// Better handling for 13-inch 1440p displays with high pixel density
const isSmallDesktop = (width >= 1024 && width <= 1500) || 
                      (pixelRatio > 1.5 && width >= 1440 && width <= 2560);
const isLargeDesktop = width > 1500 && !(pixelRatio > 1.5 && width <= 2560);

const fontFamilies = {
	Bodoni72Smallcaps: "Bodoni72Smallcaps",
};

const maxViewHeight = "500vh";

const styles = StyleSheet.create({
	body: {
		flex: 1,
		position: "relative",
		backdropFilter: "blur(10px)",
		overflow: "auto",
		overflowX: "hidden",
		minHeight: "100vh",
		width: "100vw",
		maxWidth: "100vw",
	},
	container: {
		flex: 1,
		width: "100%",
		maxWidth: "100vw",
		overflowX: "hidden",
		position: "relative",
		alignItems: "center",
		minHeight: "100vh",
	},
	section: {
		flex: 1, // Each section takes up an equal portion of the screen's height
		minHeight: isMobile ? "auto" : "100vh",
		zIndex: 1,
		left: 0,
		right: 0,
		justifyContent: "center",
		alignContent: "center",
		paddingBottom: isMobile ? 100 : 125, // Less bottom padding on mobile
		paddingTop: isMobile ? 20 : 0, // Add top padding on mobile
		top: 0,
	},
	headerBar: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		paddingHorizontal: 100,
		paddingTop: 50,
		position: "relative",
		minWidth: "100vw",
		zIndex: 98,
	},
	logoArea: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		height: 62,
		marginTop: 10,
	},
	logoText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontWeight: "normal",
		fontSize: 50,
		textAlign: "left",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	loginArea: {
		flex: 1,
		flexDirection: "row",
		backgroundColor: "transparent",
		maxHeight: 50,
	},
	loginButton: {
		width: 208,
		height: 62,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
		marginLeft: isMobile ? 15 : isTablet ? 180 : 350,
		top: isMobile ? -10 : 0,
	},
	backButton: {
		position: "absolute",
		right: 200,
		width: "auto",
		height: 62,
		backgroundColor: "transparent",
		shadowOffset: { width: 7, height: 3 },
		shadowRadius: 6,
		shadowColor: "rgba(0, 0, 0, 0.04)",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 99,
	},
	backButtonLeft: {
		position: "absolute",
		left: 200,
		width: "auto",
		height: 62,
		backgroundColor: "transparent",
		// shadowOffset: { width: 7, height: 3 },
		// shadowRadius: 6,
		// shadowColor: "rgba(0, 0, 0, 0.04)",
		alignItems: "left",
		justifyContent: "center",
		zIndex: 99,
	},
	backButtonToRegistry: {
		position: "absolute",
		top: 20,
		left: isMobile ? -85 : isTablet ? -350 : isSmallDesktop ? -435 : -475,
		width: 40, // Set a fixed width for a rounded button
		height: 40, // Height remains the same to maintain a circular shape
		backgroundColor: "red", // Changed to red background
		borderRadius: 31, // Half of width/height to make it perfectly round
		alignItems: "center", // Center align the text inside the button
		justifyContent: "center",
		zIndex: 99,
	},
	backButtonText: {
		// fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 18 : 25,
		lineHeight: 30,
		textAlign: "center",
		color: "white", // Changed text color to white
	},
	loginButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		lineHeight: 30,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	cancelButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: 25,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
		paddingRight: 90,
	},
	signOutButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: 25,
		textAlign: "center",
		color: "#4c956c",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	buttonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: 25,
		lineHeight: 30,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	backgroundImage: {
		flex: 1,
		resizeMode: "cover",
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		width: "100%",
		height: "100%",
		minHeight: "100vh",
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundAttachment: "fixed",
		zIndex: 0,
	},
	welcomeText: {
		width: 1000,
		height: 127,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: 90,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 30, height: 3 },
		textShadowRadius: 4,
		textShadowColor: "rgba(0, 0, 0, 0.06)",
		textAlign: "center",
		alignSelf: "center", 
	},
	descriptionText: {
		width: 731,
		height: 199,
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: 45,
		lineHeight: 60,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		textAlign: "center", // Change this for horizontal centering
		alignSelf: "center", // Add this for vertical centering
	},
	pageHeader: {
		width: "100%",
		maxWidth: "none",
		marginHorizontal: "auto",
		flexDirection: isMobile || isTablet ? "column" : "row",
		justifyContent: "space-between",
		alignItems: isMobile || isTablet ? "center" : "flex-start",
		paddingHorizontal: isMobile ? 20 : isTablet ? 45 : isSmallDesktop ? 60 : 100,
		paddingVertical: isMobile ? 20 : isTablet ? 30 : 40,
		zIndex: 10,
	},
	header: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 28 : isTablet ? 35 : 45,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		paddingBottom: isMobile ? 15 : 25,
		marginTop: 0,
		textAlign: "center",
	},
	yearbookContainer: {
		width: isMobile || isTablet ? "100%" : "30%",
		maxWidth: isMobile || isTablet ? 400 : "none",
		alignItems: "center",
		justifyContent: "flex-start",
		paddingHorizontal: isMobile ? 10 : isTablet ? 20 : isSmallDesktop ? 10 : 15,
		paddingVertical: isMobile ? 20 : isTablet ? 20 : 0,
		marginBottom: isMobile || isTablet ? 30 : 0,
		minHeight: isMobile || isTablet ? "auto" : 400,
		alignSelf: isMobile || isTablet ? "center" : "center",
		marginHorizontal: isMobile || isTablet ? "auto" : 0,
	},
	shareContainer: {
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		marginTop: isMobile || isTablet ? 15 : 20,
		zIndex: 1000,
	},
	shareButton: {
		width: "100%",
		maxWidth: 300,
		height: isMobile ? 60 : isTablet ? 65 : 75,
		marginHorizontal: "auto",
	},
	goalTrackerContainer: {
		width: isMobile || isTablet ? "100%" : "30%",
		maxWidth: isMobile || isTablet ? 400 : "none",
		alignItems: "center",
		justifyContent: "flex-start",
		paddingHorizontal: isMobile ? 10 : isTablet ? 20 : isSmallDesktop ? 10 : 15,
		paddingVertical: isMobile ? 20 : isTablet ? 20 : 0,
		marginBottom: isMobile || isTablet ? 30 : 0,
		minHeight: isMobile || isTablet ? "auto" : 400,
		alignSelf: isMobile || isTablet ? "center" : "center",
		marginHorizontal: isMobile || isTablet ? "auto" : 0,
	},
	eventsButton: {
		backgroundColor: "#fefde2",
		width: isMobile ? 200 : isTablet ? 250 : 284,
		height: isMobile ? 45 : isTablet ? 50 : 55,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
		border: "none",
		cursor: "pointer",
		transition: 'all 1s ease',
	},
	eventsButtonHover: {
		backgroundColor: "#e6e5cb",
		transform: "scale(1.025)",
	},
	eventsButtonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 14 : isTablet ? 16 : 20,
		lineHeight: "1.2",
		textAlign: "center",
		color: "#4c956c",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		width: "70%",
	},
	profileContainer: {
		width: "100%",
		maxWidth: isMobile || isTablet ? 400 : "none",
		alignItems: "center",
		justifyContent: "center",
		paddingHorizontal: isMobile ? 15 : isTablet ? 25 : isSmallDesktop ? 35 : 40,
		paddingVertical: isMobile ? 20 : isTablet ? 30 : isSmallDesktop ? 40 : 50,
		marginBottom: isMobile || isTablet ? 30 : 0,
		borderRadius: 250,
		zIndex: 10,
	},
	profileImage: {
		width: isMobile ? 150 : isTablet ? 200 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 150 : isTablet ? 200 : isSmallDesktop ? 200 : 250,
		borderRadius: 250,
		marginBottom: isMobile ? 8 : isTablet ? 10 : 12,
		alignSelf: 'center',
		marginHorizontal: 'auto',
	},
	sealImage: {
		width: isMobile ? 50 : 75,
		height: isMobile ? 50 : 75,
		borderRadius: 60,
		marginTop: isMobile ? 50 : isTablet ? 25 : isSmallDesktop ? 25 : 25,
		marginRight: isMobile ? 100 : 175,
		position: "absolute",
	},
	welcomeText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: 90,
		paddingBottom: 25,
		paddingTop: 50,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
	},
	profileName: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 32 : isTablet ? 48 : isSmallDesktop ? 48 : 65,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
		alignSelf: "center",
		width: "100%",
	},
	profileDetails: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 18 : isTablet ? 22 : isSmallDesktop ? 22 : 28,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
		alignSelf: "center",
		width: "100%",
	},
	profileDetailsSmall: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		paddingTop: 2,
		color: "#e4e4e4",
		fontSize: isMobile ? 16 : isTablet ? 18 : isSmallDesktop ? 18 : 20,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
		alignSelf: "center",
		width: "100%",
	},
	// New responsive layout containers
	mobileTabletLayout: {
		width: "100%",
		flexDirection: "column",
		alignItems: "center",
		paddingHorizontal: isMobile ? 15 : 20,
		paddingVertical: 10,
	},
	desktopLayout: {
		width: "100%",
		maxWidth: "none",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "stretch",
		marginHorizontal: "auto",
		paddingHorizontal: isLargeDesktop ? 60 : 40,
		paddingTop: 0,
		minHeight: 500,
		gap: isLargeDesktop ? 60 : 40,
	},
	leftColumn: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "flex-start",
		minHeight: 400,
	},
	centerColumn: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		minHeight: 400,
	},
	rightColumn: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "flex-start",
		minHeight: 400,
	},
	sectionTitle: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 28 : isTablet ? 35 : isSmallDesktop ? 40 : 45,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
	},
	yearbookSection: {
		width: "100%",
		marginBottom: 30,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	shareSection: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	goalSection: {
		width: "100%",
		marginBottom: 30,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	announcementSection: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	buttonsContainer: {
		flexDirection: isMobile ? "column" : "row",
		maxWidth: isMobile ? 380 : isTablet ? 750 : isSmallDesktop ? 1000 : 1400,
		alignSelf: "center",
		marginTop: isMobile ? 18 : isTablet ? 18 : isSmallDesktop ? 30 : 50,
		flex: 1,
		position: "relative",
		zIndex: 5,
		justifyContent: "center",
		alignItems: isMobile ? "center" : "flex-start",
	},
	buttonArea: {
		marginHorizontal: isMobile ? 35 : isTablet ? 45 : 45,
		flexDirection: "column",
		justifyContent: "center",
		alignContent: "center",
		alignSelf: "center",
		zIndex: 1000,
		marginBottom: isMobile ? 18 : 0,
	},
	button: {
		width: 284,
		height: 55,
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
		transition: 'transform 0.5s ease, background-color 0.5s ease',
	},
	buttonHover: {
		backgroundColor: "#3e7a58",
		transform: 'scale(1.025)',
	},
	buttonDescription: {
		width: 300,
		height: 96,
		paddingTop: 15,
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize: 18,
		lineHeight: 30,
		textAlign: "center",
		color: "#fefde1",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		alignSelf: "center", // Add this for vertical centering
	},
	editButton: {
		alignSelf: "flex-end",
		marginRight: "5%",
		marginTop: 20,
		paddingVertical: 10,
		paddingHorizontal: 10,
		borderRadius: 20,
		backgroundColor: "#4c956c",
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		width: "20%",
		top: 100,
		position: Platform.OS === "web" ? "fixed" : "absolute",
		zIndex: 1000,
	},
	backgroundButton: {
		alignSelf: "flex-end", // Aligns the button to the right
		marginRight: "5%", // Adds spacing from the right edge of the screen
		marginTop: 20, // Adds spacing from the top
		paddingVertical: 10,
		paddingHorizontal: 20,
		borderRadius: 20,
		backgroundColor: "#4c956c", // A green background color
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		width: "20%",
		top: 160,
		position: Platform.OS === "web" ? "fixed" : "absolute",
		zIndex: 1000, // Ensure it stays above other elements
	},
	editButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 13 : isTablet ? 16 : isSmallDesktop ? 18 : 20,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 0,
		paddingHorizontal: isMobile ? 5 : 8,
		fontWeight: 'bold',
		lineHeight: isMobile ? 14 : 18,
	},
	editControls: {
		position: "absolute", // Position absolutely to place over other content
		bottom: 0, // Align to the bottom of the parent
		left: 0, // Align to the left of the parent
		right: 0, // Align to the right of the parent
		height: 40,
		backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent background
		padding: 20, // Add some padding around the buttons
		flexDirection: "row", // Layout buttons in a row
		justifyContent: "center", // Center buttons horizontally
		alignItems: "center", // Center items vertically within the container
		justifyContent: "space-around",
		// @ts-ignore
		position: Platform.OS === "web" ? "fixed" : undefined,
	},
	previewStyle: {
		width: 100, // adjust size accordingly
		height: 50, // adjust size accordingly
	},
	prevText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: 18,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 30, height: 3 },
		textShadowRadius: 4,
		textShadowColor: "rgba(0, 0, 0, 0.06)",
		textAlign: "center", // Change this for horizontal centering
		alignSelf: "center", // Add this for vertical centering
	},
	addGridButton: {
		marginTop: 0, // Space above the button
		width: "100%", // Full width to center the button text
		alignItems: "center", // Center content horizontally in the container
	},
	addButton: {
		color: "white",
		fontSize: 30,
		textAlign: "center", // Center the '+' text horizontally
		bottom: -750,
		zIndex: 99,
	},

	savePopup: {
		position: "absolute",
		bottom: 20, // You can adjust this
		left: 0,
		right: 0,
		alignItems: "center",
	},
	savePopupText: {
		backgroundColor: "#4c956c", // Or any color you prefer
		color: "white",
		padding: 10,
		borderRadius: 5,
	},
	errorPopup: {
		position: "absolute",
		bottom: 20, // You can adjust this
		left: 0,
		right: 0,
		alignItems: "center",
		backgroundColor: "red", // Or any color you prefer
	},
	errorPopupText: {
		color: "white",
		padding: 10,
		borderRadius: 5,
	},
	// Styles for the widget placeholders within the EditablePage component
	widgetPlaceholder: {
		borderWidth: 2,
		borderColor: "#cccccc", // A light grey border color
		borderRadius: 10,
		padding: 20,
		marginBottom: 20, // Adds spacing between each widget placeholder
		alignItems: "center",
		justifyContent: "center",
	},
	// Text style for empty widget placeholders
	widgetPlaceholderText: {
		color: "#cccccc", // Light grey text color
		textAlign: "center",
	},
	// Style for the actual widgets when in non-edit mode
	widgetContainer: {
		// Style similar to widgetPlaceholder but without the border
		padding: 20,
		marginBottom: 20,
	},

	gridItem: {
		width: 400,
		height: 400,
		margin: 75,
		borderColor: "#cccccc",
		borderWidth: 2,
		borderRadius: 10,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	gridItemOccupied: {
		backgroundColor: "#f0f0f0",
		borderWidth: 1,
		borderColor: "#ccc",
	},
	deleteButton: {
		position: "absolute",
		top: isMobile ? 5 : 10,
		right: isMobile ? 5 : 10,
		backgroundColor: "red",
		padding: isMobile ? 8 : 10,
		borderRadius: 5,
		minWidth: isMobile ? 60 : 80,
		alignItems: "center",
		justifyContent: "center",
		zIndex: 10,
	},
	deleteButtonText: {
		color: "white",
		fontWeight: "bold",
		fontSize: isMobile ? 12 : 14,
	},

	modalContainer: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
		top: 0,
	},

	modalContent: {
		width: "80%", // Adjust width as needed
		height: "100%",
		alignSelf: "center", // Center horizontally
		backgroundColor: "#fefde2",
		borderBottomLeftRadius: 25, // Adjust the radius as needed
		borderBottomRightRadius: 25, // Adjust the radius as needed
		padding: 20,
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		justifyContent: "center",
		alignItems: "center",

	},
	catalogueModalContent: {
		width: "95%",
		height: "92%",
		borderRadius: 20,
		alignSelf: "center",
		backgroundColor: "#ffffff",
		paddingHorizontal: 24,
		paddingVertical: 20,
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.15,
		shadowRadius: 24,
		elevation: 8,
		flex: 1,
		alignItems: "center",
		justifyContent: "flex-start",
		top: 0,
		zIndex: 2000,
		border: "1px solid #e2e8f0",
		overflow: "hidden",
	},
	catelogueContainer: {
		flex: 1,
		alignItems: "flex-start",
		width: "100%",
		height: "100%",
		top: 0,
		overflow: "hidden",
		minHeight: 0,
		backgroundColor: "#f8fafc",
		borderRadius: 12,
		padding: 16,
		marginTop: 8,
	},
	modalSubText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: 25,
		textAlign: "center",
		color: "#4C956C", // Or any other color that fits your theme
		marginBottom: 15,
	},
	overlayBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0,0,0,0.7)", // translucent black
		backdropFilter: "blur(25px)", // Adjust the px value to control the amount of blur
		zIndex: 1,
		height: maxViewHeight,
	},
	modalToggleButton: {
		alignSelf: "flex-end",
		marginRight: "5%",
		marginTop: 10,
		paddingVertical: isMobile ? 12 : 20,
		paddingHorizontal: isMobile ? 15 : 20,
		borderRadius: isMobile ? 15 : 50,
		backgroundColor: "#4c956c",
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		top: isMobile ? 10 : 20,
		width: isMobile ? "50%" : "20%",
		minWidth: isMobile ? 140 : 180,
		maxWidth: isMobile ? 180 : 220,
		zIndex: 1000,
		alignItems: 'center',
		justifyContent: 'center',
	},
	input: {
		borderWidth: 1,
		borderColor: "#ddd",
		padding: 10,
		fontSize: 18,
		borderRadius: 6,
		marginVertical: 10,
	},
	itemText: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		color: "#333",
		textAlign: "center",
		marginVertical: 5,
	},
	imagePreview: {
		width: 100,
		height: 100,
		borderRadius: 50,
		marginVertical: 10,
	},
	input: {
		borderWidth: 1,
		borderColor: "#ddd",
		padding: 10,
		fontSize: 18,
		borderRadius: 6,
		marginVertical: 10,
	},
	gridContainer: {
		flex: 1,
		flexDirection: "row",
		flexWrap: "wrap",
		justifyContent: isMobile ? "center" : "space-around", // Center items horizontally
		alignItems: "flex-start", // Align items vertically
		paddingBottom: 250, // Space for widget menu
		paddingHorizontal: isMobile ? 10 : 0, // Add horizontal padding on mobile
		top: 0,
		position: "relative", // Ensure this is set
		width: "100%",
		gap: isMobile ? 10 : 0, // Add gap between items on mobile
	},

	itemCard: {
		backgroundColor: "#fefde2",
		borderRadius: 10, // Rounded corners
		marginVertical: isMobile ? 5 : 10, // Vertical spacing between cards
		marginHorizontal: isMobile ? 5 : 20, // Horizontal spacing from screen edges
		shadowColor: "#171717", // Shadow color
		shadowOffset: { width: 0, height: 4 }, // Shadow offset
		shadowOpacity: 0.2, // Shadow opacity
		shadowRadius: 3, // Shadow blur radius
		elevation: 5, // Elevation for Android
		alignItems: "center", // Center items horizontally in the card
		maxWidth: isMobile ? "45%" : "30%", // Better mobile width
		minWidth: isMobile ? "45%" : "250px", // Ensure minimum width
		width: isMobile ? "45%" : "auto", // Responsive width
		height: isMobile ? "auto" : 550, // Auto height on mobile
		minHeight: isMobile ? 280 : 550, // Minimum height for consistency
		maxHeight: isMobile ? "none" : 550, // Remove max height restriction on mobile
		padding: isMobile ? 10 : 15, // Better padding on mobile
	},

	itemImage: {
		width: "100%", // Full width of container
		height: isMobile ? 150 : 350, // Fixed height instead of viewport units
		borderRadius: 10, // Rounded corners for the image
		marginBottom: isMobile ? 8 : 10, // Spacing between image and text
		objectFit: "cover", // Ensure image covers the area properly
	},

	itemName: {
		fontFamily: "Orpheus Pro", // Font family
		fontSize: isMobile ? 14 : 24, // Increased mobile font size
		fontWeight: "bold", // Font weight
		color: "#333", // Text color
		textAlign: "center", // Center text
		marginBottom: isMobile ? 5 : 15, // Spacing between name and description
		lineHeight: isMobile ? 18 : 30, // Better line height for readability
	},

	itemDescription: {
		fontFamily: "Orpheus Pro", // Font family
		fontSize: isMobile ? 12 : 18, // Increased mobile font size
		color: "#333", // Text color
		textAlign: "center", // Center text
		marginBottom: isMobile ? 5 : 10, // Spacing between description and price
		lineHeight: isMobile ? 16 : 22, // Better line height for readability
	},

	itemPrice: {
		fontFamily: "Orpheus Pro", // Font family
		fontSize: isMobile ? 16 : 18, // Increased mobile font size, make it prominent
		fontWeight: "bold", // Font weight
		color: "#4c956c", // Price text color, matching the theme
		textAlign: "center", // Center text
		marginTop: isMobile ? 5 : 0, // Add top margin on mobile
	},

	addButton: {
		backgroundColor: "blue",
		padding: 10,
		margin: 20,
		borderRadius: 5,
		alignSelf: "center",
	},

	itemSelected: {
		backgroundColor: "#4c956c", // Change as needed
	},
	modalContainer: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
	},
	blurred: {
		position: "absolute",
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		backdropFilter: "blur(10px)", // Apply blur effect
		// backgroundColor: "rgba(0, 0, 0, 0.5)",
	},
	blurredContainer: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backdropFilter: "blur(10px)",
		zIndex: 9999,
	},
	modalText: {
		fontSize: 18,
	},
	confirmButton: {
		backgroundColor: '#4c956c',
		padding: 15,
		borderRadius: 5,
		marginVertical: 10,
		width: '80%',
		alignItems: 'center',
	},
	denyButton: {
		backgroundColor: 'red', // Red background
		padding: 15,
		borderRadius: 5,
		marginVertical: 10,
		width: '80%',
		alignItems: 'center',
	},
	disabledButton: {
		backgroundColor: '#cccccc', // Grey background for disabled state
		opacity: 0.6,
	},
	buttonText: {
		color: 'white',
		fontSize: 16,
		fontWeight: 'bold',
	},
	purchasedItem: {
		// Additional style for purchased items (e.g., greyed-out look)
		backgroundColor: '#cccccc',
		color: '#666666', // Assuming this affects the text color
		textDecorationLine: 'line-through', // Optionally strike-through the text
		borderRadius: 10, // Rounded corners
		padding: isMobile ? 10 : 15, // Inner spacing
		marginVertical: isMobile ? 5 : 10, // Vertical spacing between cards
		marginHorizontal: isMobile ? 5 : 20, // Horizontal spacing from screen edges
		shadowColor: "#171717", // Shadow color
		shadowOffset: { width: 0, height: 4 }, // Shadow offset
		shadowOpacity: 0.2, // Shadow opacity
		shadowRadius: 3, // Shadow blur radius
		elevation: 5, // Elevation for Android
		alignItems: "center", // Center items horizontally in the card
		maxWidth: isMobile ? "45%" : "30%", // Match itemCard width
		minWidth: isMobile ? "45%" : "250px", // Match itemCard min width
		width: isMobile ? "45%" : "auto", // Match itemCard width
		height: isMobile ? "auto" : 550, // Match itemCard height
		minHeight: isMobile ? 280 : 550, // Match itemCard min height
		maxHeight: isMobile ? "none" : 550, // Match itemCard max height
	},
	purchasedLabel: {
		// Style for the "Purchased" label
		fontWeight: 'bold',
		color: 'red',
		fontSize: isMobile ? 14 : 18,
		fontFamily: "Orpheus Pro",
		paddingBottom: isMobile ? 8 : 10,
		position: "absolute",
		top: isMobile ? 10 : 15,
		left: isMobile ? 10 : 15,
		backgroundColor: "rgba(255, 255, 255, 0.9)",
		paddingHorizontal: 8,
		paddingVertical: 4,
		borderRadius: 5,
		zIndex: 5,
	},
	modalContainer: {
		backgroundColor: '#fefde2',
		borderRadius: 10,
		padding: 20,
		width: '80%',
		maxWidth: 400,
		alignItems: 'center',
	},
	modalContent: {
		alignItems: 'center',
	},
	modalTitle: {
		fontSize: 24,
		fontWeight: 'bold',
		marginBottom: 10,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#4c956c",
	},
	catalogueModalTitle: {
		fontSize: isMobile ? 20 : 24,
		fontWeight: '600',
		marginTop: 0,
		marginBottom: 0,
		fontFamily: "system-ui, -apple-system, sans-serif",
		color: "#1e293b",
		flex: 1,
		textAlign: 'center',
		letterSpacing: '-0.025em',
	},
	shippingAddressText: {
		fontSize: 16,
		marginBottom: 20,
		textAlign: 'center',
		lineHeight: 24,
		fontFamily: fontFamilies.OrpheusProRegular,
		color: '#333',
		whiteSpace: 'pre-line', // Preserve line breaks in web
	},
	fixedContainer: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		zIndex: 1000,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	successMessage: {
		position: 'absolute',
		top: 10,
		left: '50%',
		transform: 'translateX(-50%)',
		backgroundColor: '#4c956c',
		color: 'white',
		padding: 10,
		borderRadius: 5,
		zIndex: 1001, // Ensure it appears above other elements
	},
	catalogueItem: {
		transition: 'transform 0.3s ease',
	},
	catalogueItemHover: {
		transform: 'scale(1.05)',
	},
	categoryContainer: {
		transition: 'transform 0.3s ease',
	},
	categoryContainerHover: {
		transform: 'scale(1.05)',
	},
	closeButton: {
		backgroundColor: 'red',
		padding: 15,
		borderRadius: 5,
		marginVertical: 10,
		width: '80%',
		alignItems: 'center',
	},
	continueButton: {
		backgroundColor: '#4c956c',
		padding: 15,
		borderRadius: 5,
		marginVertical: 10,
		width: '80%',
		alignItems: 'center',
	},
	buttonText: {
		color: 'white',
		fontSize: 16,
		fontWeight: 'bold',
	},
	catalogueModalHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
		position: 'relative',
		paddingVertical: 16,
		paddingHorizontal: 4,
		borderBottom: '1px solid #e2e8f0',
		marginBottom: 8,
	},

	catalogueCloseButton: {
		position: 'absolute',
		right: 8,
		top: 8,
		zIndex: 10,
		padding: 10,
		backgroundColor: '#dc2626',
		borderRadius: 50,
		width: 40,
		height: 40,
		alignItems: 'center',
		justifyContent: 'center',
		border: 'none',
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		shadowColor: '#000000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.2,
		shadowRadius: 4,
		elevation: 4,
	},
	// Responsive Desktop Layout Styles
	desktopContainer: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		maxWidth: '100%',
		overflow: 'hidden',
		marginTop: 20,
	},
	titlesRow: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: isMobile ? 10 : isTablet ? 8 : 5
	},
	componentsRow: {
		display: 'flex',
		flexDirection: isMobile || isTablet ? 'column' : 'row',
		width: '100%',
		justifyContent: 'space-evenly',
		alignItems: 'flex-start'
	},
	columnContainer: {
		flex: 1,
		height: 700,
		flexDirection: 'column',
		alignItems: 'center',
	},
	profileColumnContainer: {
		height: 700,
		flex: 1,
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	},
	widgetContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		overflow: 'visible'
	},
});

export default styles;
